export class ResponseType {
  status: string;
  msg: string;
  data: any;
}
